import { Trans } from '@lingui/macro'
import { Loading } from 'components'
import { formatError } from 'helpers'
import React, { Component } from 'react'
import { Button, Dialog, DialogContent, DialogTitle } from 'webbook-airways'

class Confirmer extends Component {
  state = {
    error: false,
    loading: false,
    errorMessage: undefined
  }

  onClickOK = () => {
    if (this.props.isPromise) {
      this.setState(
        { loading: true, errorMessage: undefined, error: false },
        () => {
          this.props
            .onConfirm()
            .then(response => {
              this.setState({ loading: false })
              return response
            })
            .catch(error => {
              const errorMessage = formatError(error, this.props.errorMessage)
              this.setState({ errorMessage, error: true, loading: false })
            })
        }
      )
    } else {
      this.props.onConfirm()
    }
  }

  render() {
    const { error, loading, errorMessage } = this.state
    const { message, onCancel } = this.props

    return (
      <Dialog open>
        <DialogTitle style={{ margin: '0 auto', textAlign: 'center' }}>
          <span style={{ color: error && 'red' }}>
            {error ? errorMessage : message}
          </span>
        </DialogTitle>
        <DialogContent style={{ margin: '0 auto' }}>
          <Button
            style={{ marginRight: 10 }}
            onClick={onCancel}
            variant={error ? 'contained' : 'text'}
            color="primary"
          >
            {error ? <Trans>OK</Trans> : <Trans>No</Trans>}
          </Button>
          {!error && (
            <Button
              color="primary"
              variant="contained"
              disabled={loading}
              onClick={this.onClickOK}
            >
              {loading ? (
                <Loading container={false} size={24} />
              ) : (
                <Trans>Yes</Trans>
              )}
            </Button>
          )}
        </DialogContent>
      </Dialog>
    )
  }
}

export default Confirmer
